import { render, staticRenderFns } from "./CoreLineStage.vue?vue&type=template&id=40bd1184&scoped=true&"
import script from "./CoreLineStage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreLineStage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreLineStage.vue?vue&type=style&index=0&id=40bd1184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd1184",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bd1184')) {
      api.createRecord('40bd1184', component.options)
    } else {
      api.reload('40bd1184', component.options)
    }
    module.hot.accept("./CoreLineStage.vue?vue&type=template&id=40bd1184&scoped=true&", function () {
      api.rerender('40bd1184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreLineStage/CoreLineStage.vue"
export default component.exports